import Box from "@mui/material/Box";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import * as React from "react";

export function LinearProgressWithLabel({
  value,
  ...props
}: LinearProgressProps & { value: number }) {
  const limitedValue = Math.min(value, 100);

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" value={limitedValue} {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          limitedValue,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}
